import { createSlice } from '@reduxjs/toolkit'

// Lesestand eines Bereichs: gefuellt vom Startpaket (_updateAll), fortgeschrieben
// durch Server-Antworten (_received, _receivedMany). Entwuerfe gibt es nicht
// mehr — jede Maske schreibt direkt und gibt die Antwort hierher (Spec
// 2026-10-05). Die oeffentliche App (src/js/app) haengt eigene Reducer an
// (customReducers, nur die in reducersConfig genannten) und extraReducers.
class ReducersFactory {
    constructor(slice, reducersConfig = [], initState = false, customReducers = false, extraReducers = false) {
        const eigene = Object.fromEntries(
            reducersConfig.filter(key => customReducers && customReducers[key]).map(key => [key, customReducers[key]])
        )
        const result = createSlice({
            name: slice,
            initialState: initState ? initState : { items: {} },
            reducers: {
                _updateAll: (state, action) => action.payload,
                _received: (state, action) => { state.items[action.payload._id] = action.payload },
                _receivedMany: (state, action) => { for (const item of action.payload) state.items[item._id] = item },
                ...eigene
            },
            ...(extraReducers && { extraReducers })
        })
        this.reducer = result.reducer
        this.actions = result.actions
    }
}

export default ReducersFactory
